export default __webpack_public_path__ + "static/marketing-social-media-f7f510720e94667dca5d5c923dbbb5a0.jpg";